'use client';

import { useTheme } from '@mui/material';
import Portal from '@mui/material/Portal';

import { Iconify } from '../iconify';

import { snackbarClasses } from './classes';
import { SnackbarRoot } from './styles';

interface SnackbarProps {
  gap?: number;
  offset?: number;
  visibleToasts?: number;
}

export function Snackbar({
  gap = 16,
  offset = 16,
  visibleToasts = 4,
}: SnackbarProps) {
  const { appSafeArea } = useTheme();

  return (
    <Portal>
      <SnackbarRoot
        expand
        gap={gap}
        closeButton
        offset={offset}
        visibleToasts={visibleToasts}
        position="top-right"
        className={snackbarClasses.root}
        toastOptions={{
          unstyled: true,
          style: {
            marginTop: appSafeArea.safeArea.top,
          },
          classNames: {
            toast: snackbarClasses.toast,
            icon: snackbarClasses.icon,
            // content
            content: snackbarClasses.content,
            title: snackbarClasses.title,
            description: snackbarClasses.description,
            // button
            actionButton: snackbarClasses.actionButton,
            cancelButton: snackbarClasses.cancelButton,
            closeButton: snackbarClasses.closeButton,
            // state
            default: snackbarClasses.default,
            info: snackbarClasses.info,
            error: snackbarClasses.error,
            success: snackbarClasses.success,
            warning: snackbarClasses.warning,
          },
        }}
        icons={{
          loading: <span className={snackbarClasses.loadingIcon} />,
          info: (
            <Iconify
              className={snackbarClasses.iconSvg}
              icon="solar:info-circle-bold"
            />
          ),
          success: (
            <Iconify
              className={snackbarClasses.iconSvg}
              icon="solar:check-circle-bold"
            />
          ),
          warning: (
            <Iconify
              className={snackbarClasses.iconSvg}
              icon="solar:danger-triangle-bold"
            />
          ),
          error: (
            <Iconify
              className={snackbarClasses.iconSvg}
              icon="solar:danger-circle-bold"
            />
          ),
          close: <Iconify width={16} icon="mingcute:close-line" />,
        }}
      />
    </Portal>
  );
}
